import React from 'react';
import { OutgoingReferralType } from '~/components/Patient';
import { getReferralAppointment } from '~/util';
import moment from 'moment';
import { OutgoingReferralModal } from '../OutgoingReferralModal';
import { ReferralStatusBadge } from '../ReferralStatusBadge';

export interface ReferralTileProps {
    outgoingReferral: OutgoingReferralType;
}
export function ReferralTile({ outgoingReferral }: ReferralTileProps) {
    const appointment = getReferralAppointment(outgoingReferral.message);
    const unreadCount = outgoingReferral.message.unread_notes_count;
    return (
        <div className="referral-card col-12 col-md-6 col-lg-4">
            <OutgoingReferralModal outgoingReferral={outgoingReferral}>
                <div className="card mb-2 border-info">
                    <div className="card-body row border-info">
                        <div className="col-12 referral-info">
                            <div
                                className="referral-reason mb-3"
                                title={outgoingReferral.message.referral_message.reason}
                            >
                                {outgoingReferral.message.referral_message.reason}
                            </div>
                            <div
                                className="referral-to-org mb-3"
                                title={
                                    outgoingReferral.message.referral_message.to_organization_name
                                }
                            >
                                {outgoingReferral.message.referral_message.to_organization_name}
                            </div>
                            <ReferralStatusBadge referral={outgoingReferral.message} />
                            {unreadCount > 0 && (
                                <span
                                    title={`${unreadCount} Unread Message${
                                        unreadCount > 1 ? 's' : ''
                                    }`}
                                >
                                    <i className="fa-solid fa-comment me-1" />
                                    {unreadCount}
                                </span>
                            )}
                            {appointment && (
                                <span
                                    title={`Patient's appointment scheduled for ${moment(
                                        appointment.appointment_date
                                    )
                                        .utc(false)
                                        .format('MMM DD YYYY')}${
                                        appointment.time_pending
                                            ? ''
                                            : ` at ${moment(appointment.appointment_date)
                                                  .utc(false)
                                                  .format('h:mm a')}`
                                    }`}
                                    className="referral-appointment badge badge-outline-secondary float-end"
                                >
                                    <i className="fa-solid fa-calendar me-1" />
                                    {moment(appointment.appointment_date)
                                        .utc(false)
                                        .format('MMM DD YYYY')}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </OutgoingReferralModal>
        </div>
    );
}
